/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { BatteryFixedVoltages } from '../models/BatteryFixedVoltages';
import type { BatteryLookupTable } from '../models/BatteryLookupTable';
import type { BatteryLookupTableID } from '../models/BatteryLookupTableID';
import type { Body_add_thermal_model_components_thermal_model_post } from '../models/Body_add_thermal_model_components_thermal_model_post';
import type { Body_create_component_data_from_file_components_upload_file_post } from '../models/Body_create_component_data_from_file_components_upload_file_post';
import type { Body_create_file_items_components_upload_post } from '../models/Body_create_file_items_components_upload_post';
import type { ComponentFileType } from '../models/ComponentFileType';
import type { ComponentInDB } from '../models/ComponentInDB';
import type { ComponentLossMapArgs } from '../models/ComponentLossMapArgs';
import type { DisconnectClutchInput } from '../models/DisconnectClutchInput';
import type { FileParameters } from '../models/FileParameters';
import type { InverterAnalytical } from '../models/InverterAnalytical';
import type { InverterLossMapID } from '../models/InverterLossMapID';
import type { ItemAndBlobs } from '../models/ItemAndBlobs';
import type { MotorLab } from '../models/MotorLab';
import type { MotorLabID } from '../models/MotorLabID';
import type { MotorLossMap } from '../models/MotorLossMap';
import type { MotorLossMapID } from '../models/MotorLossMapID';
import type { MotorTorqueCurves } from '../models/MotorTorqueCurves';
import type { MotorTorqueCurvesID } from '../models/MotorTorqueCurvesID';
import type { SubmittedJob } from '../models/SubmittedJob';
import type { ThermalModelDetails } from '../models/ThermalModelDetails';
import type { TransmissionLossCoefficients } from '../models/TransmissionLossCoefficients';
import type { TransmissionLossMap } from '../models/TransmissionLossMap';
import type { TransmissionLossMapID } from '../models/TransmissionLossMapID';
import type { TransmissionNeglect } from '../models/TransmissionNeglect';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class ComponentsService {
    constructor(public readonly http: HttpClient) {}
    /**
     * Create
     * Create from parameters.
     * @param requestBody
     * @param designId
     * @param designInstanceId
     * @returns ComponentInDB Successful Response
     * @throws ApiError
     */
    public createComponentsPost(
        requestBody: ((BatteryFixedVoltages | BatteryLookupTable | MotorTorqueCurves | MotorLossMap | MotorLab | TransmissionLossCoefficients | TransmissionLossMap | TransmissionNeglect | InverterAnalytical | DisconnectClutchInput | MotorLossMapID | MotorLabID | MotorTorqueCurvesID | BatteryLookupTableID | TransmissionLossMapID | InverterLossMapID) | ItemAndBlobs),
        designId?: (string | null),
        designInstanceId?: (string | null),
    ): Observable<ComponentInDB> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/components',
            query: {
                'design_id': designId,
                'design_instance_id': designInstanceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Component Data From File
     * Create component part from uploaded file.
     * @param fileParameters
     * @param accountId
     * @param formData
     * @param designId
     * @param designInstanceId
     * @returns SubmittedJob Successful Response
     * @throws ApiError
     */
    public createComponentDataFromFileComponentsUploadFilePost(
        fileParameters: FileParameters,
        accountId: string,
        formData: Body_create_component_data_from_file_components_upload_file_post,
        designId?: (string | null),
        designInstanceId?: (string | null),
    ): Observable<SubmittedJob> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/components:upload_file',
            query: {
                'file_parameters': fileParameters,
                'design_id': designId,
                'design_instance_id': designInstanceId,
                'account_id': accountId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * @deprecated
     * Create File Items
     * Create component from uploaded file.
     *
     * Returns the created file item ID and any extracted data needed by the UI in a dict.
     * @param componentFileType
     * @param formData
     * @param returnSpeedOnly
     * @param designId
     * @param designInstanceId
     * @returns any[] Successful Response
     * @throws ApiError
     */
    public createFileItemsComponentsUploadPost(
        componentFileType: ComponentFileType,
        formData: Body_create_file_items_components_upload_post,
        returnSpeedOnly: boolean = true,
        designId?: (string | null),
        designInstanceId?: (string | null),
    ): Observable<any[]> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/components:upload',
            query: {
                'component_file_type': componentFileType,
                'return_speed_only': returnSpeedOnly,
                'design_id': designId,
                'design_instance_id': designInstanceId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Add Thermal Model
     * Add a thermal model to an existing file item e.g. MotorLabDataInDB.
     *
     * Currently only works for legacy components with data in DB, need to implement for
     * S3 as well.
     * @param itemId
     * @param formData
     * @param designId
     * @param designInstanceId
     * @returns ThermalModelDetails Successful Response
     * @throws ApiError
     */
    public addThermalModelComponentsThermalModelPost(
        itemId: string,
        formData: Body_add_thermal_model_components_thermal_model_post,
        designId?: (string | null),
        designInstanceId?: (string | null),
    ): Observable<ThermalModelDetails> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/components:thermal_model',
            query: {
                'design_id': designId,
                'design_instance_id': designInstanceId,
                'item_id': itemId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Read
     * Get from ID.
     * @param itemId
     * @param designId
     * @param designInstanceId
     * @returns ComponentInDB Successful Response
     * @throws ApiError
     */
    public readComponentsItemIdGet(
        itemId: string,
        designId?: (string | null),
        designInstanceId?: (string | null),
    ): Observable<ComponentInDB> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/components/{item_id}',
            path: {
                'item_id': itemId,
            },
            query: {
                'design_id': designId,
                'design_instance_id': designInstanceId,
            },
            errors: {
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update
     * Update with new parameters.
     * @param itemId
     * @param requestBody
     * @param designId
     * @param designInstanceId
     * @returns ComponentInDB Successful Response
     * @throws ApiError
     */
    public updateComponentsItemIdPut(
        itemId: string,
        requestBody: (BatteryFixedVoltages | BatteryLookupTable | MotorTorqueCurves | MotorLossMap | MotorLab | TransmissionLossCoefficients | TransmissionLossMap | TransmissionNeglect | InverterAnalytical | DisconnectClutchInput | MotorLossMapID | MotorLabID | MotorTorqueCurvesID | BatteryLookupTableID | TransmissionLossMapID | InverterLossMapID),
        designId?: (string | null),
        designInstanceId?: (string | null),
    ): Observable<ComponentInDB> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/components/{item_id}',
            path: {
                'item_id': itemId,
            },
            query: {
                'design_id': designId,
                'design_instance_id': designInstanceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete
     * Delete by ID.
     * @param itemId
     * @param designId
     * @param designInstanceId
     * @returns any Successful Response
     * @throws ApiError
     */
    public deleteComponentsItemIdDelete(
        itemId: string,
        designId?: (string | null),
        designInstanceId?: (string | null),
    ): Observable<any> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/components/{item_id}',
            path: {
                'item_id': itemId,
            },
            query: {
                'design_id': designId,
                'design_instance_id': designInstanceId,
            },
            errors: {
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * @deprecated
     * Calc Display Data
     * Calculate component data from an ID.
     * @param componentId
     * @param designId
     * @param designInstanceId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public calcDisplayDataComponentsGetDisplayDataPost(
        componentId: string,
        designId?: (string | null),
        designInstanceId?: (string | null),
        requestBody?: (ComponentLossMapArgs | null),
    ): Observable<any> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/components:get_display_data',
            query: {
                'component_id': componentId,
                'design_id': designId,
                'design_instance_id': designInstanceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Calc Image Data
     * Calculate component data from an ID.
     * @param componentId
     * @param designId
     * @param designInstanceId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public calcImageDataComponentsImageDataPost(
        componentId: string,
        designId?: (string | null),
        designInstanceId?: (string | null),
        requestBody?: (ComponentLossMapArgs | null),
    ): Observable<any> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/components:image_data',
            query: {
                'component_id': componentId,
                'design_id': designId,
                'design_instance_id': designInstanceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not found`,
                422: `Validation Error`,
            },
        });
    }
}
